// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages {
    padding: 5px;
    overflow: auto;
    flex: auto;
  }
  .container2{
    margin-left: 5%;
  }
  .paragraph{
    margin-left: 0%;
  }
  .react-scroll-to-bottom--css-azget-1tj0vk3{
    display: none;
  }`, "",{"version":3,"sources":["webpack://./src/pages/Chatbot_v2/components/Messages/Messages.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,cAAc;IACd,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf","sourcesContent":[".messages {\n    padding: 5px;\n    overflow: auto;\n    flex: auto;\n  }\n  .container2{\n    margin-left: 5%;\n  }\n  .paragraph{\n    margin-left: 0%;\n  }\n  .react-scroll-to-bottom--css-azget-1tj0vk3{\n    display: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
